module.exports = __webpack_public_path__ + "img/main.6fafa2b9.png";